package dev.wyns.ventrova.platform

import androidx.compose.runtime.Composable
import androidx.compose.runtime.staticCompositionLocalOf

/** Lets layouts react to "back": the system back gesture on Android, the browser history on web. */
interface BackNavigation {
    /** While [enabled], back calls [onBack] instead of leaving the screen. */
    @Composable
    fun BackHandler(enabled: Boolean, onBack: () -> Unit)
}

object NoBackNavigation : BackNavigation {
    @Composable
    override fun BackHandler(enabled: Boolean, onBack: () -> Unit) = Unit
}

val LocalBackNavigation = staticCompositionLocalOf<BackNavigation> { NoBackNavigation }
